export default __webpack_public_path__ + "static/media/closeFilter.695de141.svg";